const DefaultStorageConfiguration = {
    ONE: {
        model: "one",
        bat: [{ batType: "ATL", minDCBCount: 2, maxDCBCount: 5 }],
        availableCapacity: [5.5, 8.7, 11.8],
        maxDCDCPower: 6000,
        maxDCPower: 18000,
        couplingMode: ["DC", "AC", "HYBRID"],
        farmingAble: true,
        color: ["white"],
        mounting: ["wallmount"],
        price: 3,
        dcLimits: {
            maxTrackerCount: 3,
            maxMppVoltage: 850,
            minMppVoltage: 150,
            maxDcVoltage: 1000,
            maxDcCurrentPerStringMultiTracker: 16,
            maxDcCurrentPerStringSingleTracker: 16,
            recommendedDcPower: 16000,
            maxDcPower: 18000
        }
    },
    SESERIE: {
        model: "S10 SE",
        bat: [{ batType: "ATL", minDCBCount: 3, maxDCBCount: 3 }],
        availableCapacity: [8.2],
        maxDCDCPower: 4500,
        maxDCPower: 12500,
        couplingMode: "DC",
        farmingAble: true,
        color: ["white"],
        mounting: ["foot"],
        price: 3,
        dcLimits: {
            maxTrackerCount: 2,
            maxMppVoltage: 850,
            minMppVoltage: 150,
            maxDcVoltage: 1000,
            maxDcCurrentPerStringMultiTracker: 13,
            maxDcCurrentPerStringSingleTracker: 13,
            recommendedDcPower: 12500,
            maxDcPower: 12500
        }
    },
    XSERIE: {
        model: "S10 X Hauskraftwerk",
        bat: [{ batType: "ATL", minDCBCount: 6, maxDCBCount: 7 }],
        availableCapacity: [17.4, 20.6],
        maxDCDCPower: 3000,
        maxDCPower: 18000,
        couplingMode: "DC",
        farmingAble: true,
        color: ["white"],
        mounting: ["foot"],
        price: 3,
        dcLimits: {
            maxTrackerCount: 2,
            maxMppVoltage: 850,
            minMppVoltage: 250,
            maxDcVoltage: 1000,
            maxDcCurrentPerStringMultiTracker: 27,
            maxDcCurrentPerStringSingleTracker: 27,
            recommendedDcPower: 18000,
            maxDcPower: 18000
        }
    },
    XCOMPACT: {
        model: "S10 X COMPACT",
        bat: [{ batType: "ATL", minDCBCount: 3, maxDCBCount: 4 }],
        availableCapacity: [8.25, 11.2],
        maxDCDCPower: 3000,
        maxDCPower: 18000,
        couplingMode: "DC",
        farmingAble: true,
        color: ["white"],
        mounting: ["foot"],
        price: 3,
        dcLimits: {
            maxTrackerCount: 2,
            maxMppVoltage: 850,
            minMppVoltage: 250,
            maxDcVoltage: 1000,
            maxDcCurrentPerStringMultiTracker: 27,
            maxDcCurrentPerStringSingleTracker: 27,
            recommendedDcPower: 18000,
            maxDcPower: 18000
        }
    },
    S20XPRO: {
        model: "S20 X PRO",
        bat: [{ batType: "ATL", minDCBCount: 7, maxDCBCount: 14 }],
        availableCapacity: [20.6, 41.2, 60.9, 81.2],
        maxDCDCPower: 3000,
        maxDCPower: 45000,
        couplingMode: "DC",
        farmingAble: true,
        color: ["black"],
        mounting: ["foot"],
        price: 3,
        dcLimits: {
            maxTrackerCount: 3,
            maxMppVoltage: 850,
            minMppVoltage: 250,
            maxDcVoltage: 1000,
            maxDcCurrentPerStringMultiTracker: 33,
            maxDcCurrentPerStringSingleTracker: 33,
            recommendedDcPower: 45000,
            maxDcPower: 45000
        }
    },
    // PROSERIE: {
    //     model: "S10 E PRO Hauskraftwerk",
    //     bat: [{ batType: "LG", minDCBCount: 2, maxDCBCount: 6 }],
    //     availableCapacity: [11.7, 17.5],
    //     maxDCDCPower: 9000,
    //     maxDCPower: 15000,
    //     couplingMode: "DC",
    //     farmingAble: true,
    //     color: ["black"],
    //     mounting: ["wallmount", "foot"],
    //     price: 3,
    //     dcLimits: {
    //         maxTrackerCount: 2,
    //         maxMppVoltage: 850,
    //         minMppVoltage: 250,
    //         maxDcVoltage: 1000,
    //         maxDcCurrentPerStringMultiTracker: 18,
    //         maxDcCurrentPerStringSingleTracker: 19,
    //         recommendedDcPower: 15000,
    //         maxDcPower: 17000
    //     }
    // },
    PROCOMPACT: {
        model: "S10 E PRO COMPACT",
        bat: [{ batType: "LG", minDCBCount: 2, maxDCBCount: 5 }],
        availableCapacity: [11.7, 17.5, 23.4, 29.2],
        maxDCDCPower: 9000,
        maxDCPower: 20000,
        couplingMode: "DC",
        farmingAble: true,
        color: ["black"],
        mounting: ["foot"],
        price: 3,
        dcLimits: {
            maxTrackerCount: 2,
            maxMppVoltage: 850,
            minMppVoltage: 250,
            maxDcVoltage: 1000,
            maxDcCurrentPerStringMultiTracker: 27,
            maxDcCurrentPerStringSingleTracker: 27,
            recommendedDcPower: 20000,
            maxDcPower: 20000
        }
    }
}

export default DefaultStorageConfiguration;
